module.exports = "/images/UnitedStates.png?33f0e333ac0f82d53446f29926db07e7";